import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const UploadDisclaimer = styled.div`
  height: 16px;
  margin-top: 8px;
  text-align: center;
  ${typographyV2.bodyXs};
`;

export const StyledAnchor = styled.a`
  ${typographyV2.bodyXs};
  color: var(--surface-primary);
  text-decoration: none;

  &:hover {
    color: var(--surface-primary);
    text-decoration: underline;
  }
`;
